export default __webpack_public_path__ + "static/media/footer-instagram.71344d02.svg";